import { inject, Pipe, PipeTransform } from '@angular/core';
import { IconKey } from '../../../../../whitelabel/icon-key.enum';
import { LanguageService } from '../../../../core/services/language.service';
import { OptionResolver } from '../../../../shared/components/card-select/contract/options-resolver.contract';
import { IconProviderService } from '../../../../whitelabel/services/icon-provider.service';
import { StockType } from '../enums/stock-type.enum';

@Pipe({
  name: 'stockType',
  standalone: true,
})
export class StockTypeResolver implements OptionResolver, PipeTransform {
  private languageService = inject(LanguageService);
  private iconProviderService = inject(IconProviderService);

  private definitionSet = {
    [StockType.PERSON]: {
      name: this.translate('shared.pipes.stockType.person'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypePerson),
    },
    [StockType.CONTAINER]: {
      name: this.translate('shared.pipes.stockType.container'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypeContainer),
    },
    [StockType.POSITION]: {
      name: this.translate('general.location.s'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypePosition),
    },
    [StockType.VEHICLE]: {
      name: this.translate('shared.pipes.stockType.vehicle'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypeVehicle),
    },
    [StockType.STOCK]: {
      name: this.translate('general.stock.s'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypeStock),
    },
    [StockType.MAIN]: {
      name: this.translate('shared.pipes.stockType.mainStock'),
      icon: this.iconProviderService.getIcon(IconKey.StockTypeMain),
    },
  };

  transform(value: StockType): string {
    return this.resolveName(value);
  }

  resolveName(option: StockType): string {
    return this.definitionSet[option]?.name || this.translate('general.unknown');
  }

  resolveIcon(option: StockType): string {
    return this.definitionSet[option]?.icon || '';
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
